import React, { useContext } from "react";
import { Box, Paper } from "@mui/material";
import { MainContext, MainContextState } from "../../context/MainContext";
import CustomButton from "../UI/CustomButton/CustomButton";
// import classes from "./Header.module.css";
import { ReactComponent as Logo } from "../../styles/logo.svg";
import { ReactComponent as ManIcon } from "../../styles/man.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { LinkBehavior } from "../LinkBehavior/LinkBehavior";

const Header = () => {
    const location = useLocation();
    const { user, setUser } = useContext<Partial<MainContextState>>(MainContext);
    const token = localStorage.getItem("token");
    const navigate = useNavigate();
    const tokenRevoke = () => {
        if (setUser) {
            setUser(null);
        }
        localStorage.removeItem("token");
        localStorage.removeItem("admin_role");
        localStorage.removeItem("employee_center_id");
        navigate("/authorization");
    };
    return (
        <header>
            <Paper
                sx={{
                    display: "flex",
                    p: "10px 80px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    ".header__logo": {
                        svg: {
                            height: "75px",
                        },
                    },
                    ".header__actions": {
                        svg: {
                            pr: "5px",
                            height: "1rem",
                        },
                    },
                }}
                square>
                <Box className={"header__logo"} component={LinkBehavior} to={"/"}>
                    <Logo />
                </Box>
                {/*<h1>Единая мониторинговая платформа центров прототипирования</h1>*/}
                <div className={"header__actions"}>
                    {token || !!user ? (
                        <CustomButton
                            onClick={() => {
                                location.pathname === "/" && token ? navigate("/personal/data") : tokenRevoke();
                            }}
                            sx={{ width: "170px" }}>
                            {" "}
                            <ManIcon />
                            {location.pathname === "/" ? "ЛК" : "Выйти из системы"}
                        </CustomButton>
                    ) : (
                        <CustomButton
                            sx={{ width: "170px" }}
                            onClick={() => {
                                navigate("/authorization");
                            }}>
                            <ManIcon />
                            Войти в систему
                        </CustomButton>
                    )}
                </div>
            </Paper>
        </header>
    );
};

export default Header;
